const classNameBased = 'is-changed';

function ChangeClassNamePlugin($pool, $dataProxy) {
  const classNameRegExp = new RegExp(`${classNameBased}-[-_a-z]{3}`, 'i');

  return function run(eventName, { Controller, mode, newMode }) {
    if (eventName !== 'Row:changeMode') return;

    const className = `${classNameBased}-${mode}-${newMode}`;

    $pool.push('Table:changeMode::mutate', () => {
      Controller.cells.forEach(cell => {
        classNameRegExp.lastIndex = 0;
        const idx = [...cell.classList].findIndex(c => classNameRegExp.test(c));

        if (idx) cell.classList.remove(cell.classList[idx]);
        // Does not add the change class if the table returns to its initial mode
        if ($dataProxy.prop('initialMode') === newMode) return;
        cell.classList.add(className);
      });
    });
  };
}

export default ChangeClassNamePlugin;
